module.exports = __webpack_public_path__ + "static/media/video-02-shelfzone.4287cfe0.mp4";